import { render } from "./MailIcon.vue?vue&type=template&id=f775ee78&scoped=true"
import script from "./MailIcon.vue?vue&type=script&lang=js"
export * from "./MailIcon.vue?vue&type=script&lang=js"

import "./MailIcon.vue?vue&type=style&index=0&id=f775ee78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f775ee78"]])

export default __exports__